// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "ui" + "-" + "c2fba577a1585e5c" + ".js";
};